import { ILandingFloat, ILandingSection } from "../../../../data/interfaces"
import Float from "./Float"

/* Protopia Ecosystem component */
export interface IFloatsProps {
    floats: ILandingFloat[] 
    section: ILandingSection
    isCanvas?: boolean
}
const Floats = (props: IFloatsProps): JSX.Element => {
    return <> 
        {
            props.floats?.map((float: ILandingFloat, i:number) => { 
                return <Float key={ float.id } float={{ ...float, isCanvas: props.isCanvas }} i={ i } section={props.section} />
            })
        }
    </>
}
export default Floats